import { useCallback, useState } from 'react';
import { isSameDateRange } from '../../services/helpers/DateRangeHelpers';

/**
 * Date-range filter state whose setter ignores a filter equal to the current one, so effects keyed
 * on the filter do not refetch when DateRangePicker re-announces the selection it already holds.
 */
export default function useDateRangeFilter(initial) {
  const [filter, setFilter] = useState(initial);

  const updateFilter = useCallback(
    (next) => setFilter((current) => (isSameDateRange(current, next) ? current : next)),
    [],
  );

  return [filter, updateFilter];
}
